// AgentDetailsPage.jsx

import PageContainer from "../../components/common/PageContainer";
import useAgentDetailsPage from "../../hooks/useAgentDetailsPage";

import AgentHeader from "../../components/agents/AgentHeader";
import AgentConfigurations from "../../components/agents/AgentConfigurations";
import AgentPropertiesSection from "../../components/agents/AgentPropertiesSection";
import AgentSettingsModals from "../../components/agents/AgentSettingsModals";

import AgentBasicInfoSection from "../../components/agents/AgentBasicInfoSection";
import Loader from "../../components/ui/Loader/Loader";

export default function AgentDetailsPage() {
  const state = useAgentDetailsPage();

  if (state.isLoading ) {
    return <Loader />;
  }

  return (
    <PageContainer >
      <section className="agent-details-page">
      <AgentHeader navigate={state.navigate} />
      <AgentBasicInfoSection />
      <AgentConfigurations
        openLeadScoreModal={state.openLeadScoreModal}
        openChatboxModal={state.openChatboxModal}
        onOpenSettings={() => state.setShowSettingsModal(true)}
        agentDetails={state.agentDetails}
      />
      <AgentPropertiesSection
        agentId={state.agentDetails?.agent?.id}
        setSelectedProperty={state.setSelectedProperty}
        />
        <AgentSettingsModals {...state} />
      </section>
    </PageContainer>
  );
}